//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Banner',
  props: {
    isSearching: {
      type: Boolean,
      required: true
    },
    isCartOpen: {
      type: Boolean,
      required: false
    }
  },
  methods: {
    updateSize() {
      this.$emit('updateSize')
    }
  }
}
